import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar";
import { addDateTz } from "pages/media/utils";
import type { InsightMetric } from "../../types";
import type { ReactNode } from "react";

dayjs.extend(calendar);

const JUST_NOW_THRESHOLD_MINUTES = 1;

/** "Just now" / "Today at HH:mm" / "Yesterday at HH:mm" / "MMM D, YYYY at HH:mm". */
export const formatCommentTimestamp = (
  date: string,
  t: (key: string) => string
): string => {
  const commentDate = dayjs(addDateTz(date));

  if (dayjs().diff(commentDate, "minute") < JUST_NOW_THRESHOLD_MINUTES) {
    return t("media.analytics.insights.commentJustNow");
  }

  return commentDate.calendar(null, {
    sameDay: `[${t("media.analytics.insights.commentToday")}] HH:mm`,
    lastDay: `[${t("media.analytics.insights.commentYesterday")}] HH:mm`,
    sameElse: `MMM D, YYYY [${t("media.analytics.insights.commentDateAt")}] HH:mm`,
  });
};

export const formatMetricValue = (metric: InsightMetric): ReactNode => {
  if (metric.value_max !== null) {
    return `${metric.value ?? "—"} / ${metric.value_max}`;
  }
  // InsightMetric has no unit field — "_pct" in the key is the only signal
  // that this value is a percentage rather than a count/duration/score.
  // The label already carries the "%" unit, so just round here.
  if (metric.key.endsWith("_pct") && metric.value != null) {
    return Math.round(metric.value);
  }
  return metric.value ?? "—";
};
